import { Col, Row, Skeleton } from "antd"
import { useMemo, useState } from "react"
import { OrderInfoInterface } from "../../types"
import { ContainerFull } from "../GeneralComponents"
import { OrderSummary } from "./OrderSummary"

import { useQuery } from "@tanstack/react-query"
import { getPrice, ShowMessagePage } from "../../config"

import { useTheme } from "styled-components"
import { getProducts } from "../../endpoints"
import { Payment } from "./Payment"
import { Shipping } from "./Shipping"

interface PreviewOrderProps {
    orderInfo: OrderInfoInterface
    setOrderInfo: React.Dispatch<React.SetStateAction<OrderInfoInterface>>
    setCurrentStep: React.Dispatch<React.SetStateAction<number>>
}

export const PreviewOrder = (props: PreviewOrderProps): JSX.Element => {
    const [discountedPrice, setDiscountedPrice] = useState<number | null>(null)
    
    const theme = useTheme()
    const { isPending, isError, data, error } = useQuery({
        queryKey: ["getproducts"],
        queryFn: getProducts,
    })

    const totalPrice = useMemo(() => {
        const sampleNames = props.orderInfo.samples.map((s) => s.sampleName)
        switch (props.orderInfo.productid) {
            case null:
                return { price: 0, unit: "USD", country: "USA" }

            default:
                let unitPrice = getPrice(data?.products.find((x) => x.id === props.orderInfo.productid)?.price)
                if (unitPrice && props.orderInfo.colonies) {
                    unitPrice += 5
                }
                if (discountedPrice !== null) return { price: discountedPrice, unit: "USD", country: "USA" }
                else return { price: (unitPrice ?? 0) * sampleNames.length, unit: "USD", country: "USA" }
        }
    }, [props.orderInfo.samples, props.orderInfo.productid, data?.products, discountedPrice,props.orderInfo.colonies])

    if (isPending) {
        return <Skeleton />
    }

    if (isError) {
        return ShowMessagePage("Error", error.message)
    }

    return (
        <ContainerFull style={{ fontFamily: '"Rubik", sans-serif' }}>
            {props.orderInfo.samples.length === 0 && (
                <div style={{ textAlign: "center", marginTop: "2em" }}>
                    <h2 style={{ color: theme.primary }}>No samples added to the order</h2>
                    <p>Please add samples to proceed with the order.</p>
                </div>
            )}
            {props.orderInfo.productid != null && props.orderInfo.samples.length > 0 && (
                <div style={{ borderStyle: " none" }}>
                    <Row justify="space-evenly">
                        <Col xl={14} lg={24} md={24} sm={24} xs={24}>
                        <Row>
                            <Col span={24}>
                                <Shipping orderInfo={props.orderInfo} setOrderInfo={props.setOrderInfo} />
                            </Col>
                            </Row>
                            <Row>
                            <Col span={24} style={{ marginTop: "2em" }}>
                                <Payment orderInfo={props.orderInfo} setOrderInfo={props.setOrderInfo} totalPrice={totalPrice} />
                            </Col></Row>
                        </Col>

                        <Col xl={8} lg={24} md={24} sm={24} xs={24}>
                            <OrderSummary
                                orderInfo={props.orderInfo}
                                setOrderInfo={props.setOrderInfo}
                                
                                totalPrice={totalPrice}
                                // totalPrice={{price:1000,unit:'USD',country:'USA'}}
                                setDiscountedPrice={setDiscountedPrice}
                                setCurrentStep={props.setCurrentStep}
                            />
                        </Col>
                    </Row>
                </div>
            )}
        </ContainerFull>
    )
}
